import { useListSupportedAppsQuery } from '../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AppRpc.hooks';

type TUseUnifiedAccountSupportedAppsArgs = {
  skip?: boolean;
};

export const useUnifiedAccountSupportedApps = (
  args?: TUseUnifiedAccountSupportedAppsArgs
) => {
  const { data, loading, error, networkStatus } = useListSupportedAppsQuery({
    skip: args?.skip ?? false,
  });

  return {
    data: data?.supportedApps || [],
    loading,
    error: error || null,
    networkStatus,
  };
};
